import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { cardMessages } from 'src/features/cards/utils/messages';
import { useGetPricingPlanDetails } from 'src/features/pricingPlans/api/useGetPricingPlanDetails';
import { ASSIGMENT_CODE } from 'src/features/pricingPlans/types';
import { pricingPlanNamesMessages } from 'src/features/pricingPlans/utils/messages';
import {
    GeneralBlock,
    GeneralBlockHead,
    GeneralBlockHeader,
    GeneralBlockSeparator,
    GeneralBlockSubtitle,
} from 'src/registry/components/blocks/GeneralBlock';
import { Button } from 'src/registry/ui/Button';
import { Skeleton } from 'src/registry/ui/Skeleton';

type StatisticCardsProps = {
    onChangeAssignment: ({ code, planId }: { code: ASSIGMENT_CODE; planId: number | null }) => void;
    card: {
        code: ASSIGMENT_CODE;
        id: number | null;
    };
    areAssignmentsLoading: boolean;
    showEdit: boolean;
};

export default function ParkingPricingCards({
    onChangeAssignment,
    card,
    areAssignmentsLoading,
    showEdit,
}: StatisticCardsProps) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParams();
    const { data: planDetails, isLoading } = useGetPricingPlanDetails({
        planId: card.id,
        parkingId: parkingId!,
        config: { enabled: !!parkingId },
    });

    return (
        <GeneralBlock className="gap-2" key={card.id}>
            <GeneralBlockHeader className="flex-1 flex-col items-start">
                <GeneralBlockSubtitle>{formatMessage(pricingPlanNamesMessages[card.code])}</GeneralBlockSubtitle>
                <GeneralBlockHead className="-mt-2 text-lg font-bold xl:text-xl">
                    {isLoading || areAssignmentsLoading ? (
                        <Skeleton className="h-8 w-48" />
                    ) : planDetails ? (
                        planDetails.plan_name
                    ) : (
                        'N/A'
                    )}
                </GeneralBlockHead>
            </GeneralBlockHeader>
            {showEdit && (
                <>
                    <GeneralBlockSeparator className="my-2" />
                    <div className="flex justify-end">
                        <Button
                            variant="ghost"
                            onClick={() => {
                                if (isLoading) return;
                                onChangeAssignment({
                                    code: card.code,
                                    planId: planDetails ? planDetails.id : null,
                                });
                            }}
                            size="sm"
                            className="-my-2"
                        >
                            <span className="text-primary-700 text-sm font-semibold">
                                {formatMessage(cardMessages.changePlan)}
                            </span>
                        </Button>
                    </div>
                </>
            )}
        </GeneralBlock>
    );
}
